<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-8 ml-auto">
                <div class="text-right">
                  <router-link :to="{ name: 'site-photos-new' }" class="btn btn-success btn-rounded mb-2">
                    <i class="mdi mdi-plus mr-1"></i> Nova Foto
                  </router-link>
                </div>
              </div>
            </div>

            <draggable v-model="list" class="row" @end="updateSequence" handle=".handle" v-if="list.length > 0">
              <div v-for="(item, index) in list" :key="item.id" class="col-xl-3 col-sm-6">
                <div class="card">
                  <img class="card-img-top img-fluid" :src="item.photo" alt="Foto do evento" style="height: 200px; object-fit: cover;">
                  <div class="card-body">
                    <div class="d-flex align-items-center mb-2">
                      <i class="mdi mdi-drag-vertical text-muted handle" style="cursor: move; font-size: 20px;"></i>
                      <span class="badge badge-soft-primary font-size-12 ml-2">#{{ index + 1 }}</span>
                      <div class="ml-auto">
                        <div class="custom-control custom-switch">
                          <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="'switch' + item.id"
                            :checked="item.status"
                            @change="toggleStatus(item.id)"
                          />
                          <label class="custom-control-label" :for="'switch' + item.id"></label>
                        </div>
                      </div>
                    </div>
                    <h5 class="card-title font-size-14 mb-1">{{ item.title || 'Sem título' }}</h5>
                    <p class="card-text text-muted" style="font-size: 12px; min-height: 36px;">
                      {{ item.description ? item.description.substring(0, 60) : '' }}{{ item.description && item.description.length > 60 ? '...' : '' }}
                    </p>
                    <div class="d-flex">
                      <router-link :to="{ name: 'site-photos-edit', params: { id: item.id } }" class="btn btn-sm btn-success mr-2">
                        <i class="mdi mdi-pencil"></i> Editar
                      </router-link>
                      <button @click="confirmDelete(item.id)" class="btn btn-sm btn-danger">
                        <i class="mdi mdi-trash-can"></i> Excluir
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </draggable>

            <div v-else class="text-center py-5">
              <i class="mdi mdi-image-multiple-outline" style="font-size: 48px; color: #ced4da;"></i>
              <p class="text-muted mt-2">Nenhuma foto cadastrada</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import draggable from 'vuedraggable'
import { mapActions, mapState } from 'vuex'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import Swal from 'sweetalert2'

export default {
  components: { Layout, PageHeader, draggable },
  data () {
    return {
      title: 'Fotos do Evento',
      items: [{ text: 'Site', href: '/' }, { text: 'Fotos', active: true }],
      list: []
    }
  },
  computed: {
    ...mapState('photos', { data: 'photos' })
  },
  mounted () {
    this.loadPhotos()
  },
  methods: {
    ...mapActions('photos', {
      fetch: 'GetPhotos',
      updateStatus: 'changeStatus',
      deleteItem: 'deletePhoto',
      reorder: 'orderList'
    }),
    async loadPhotos () {
      let loader = this.$loading.show()
      await this.fetch({ limit: 1000 })
      this.list = this.data.data || []
      loader.hide()
    },
    async toggleStatus (id) {
      try {
        await this.updateStatus(id)
        successMessage('Status atualizado!')
        this.loadPhotos()
      } catch (error) {
        errorMessage('Erro ao atualizar status.')
      }
    },
    async updateSequence () {
      try {
        const photos = this.list.map(item => item.id)
        await this.reorder({ photos })
        successMessage('Ordem atualizada!')
      } catch (error) {
        errorMessage('Erro ao reordenar.')
      }
    },
    confirmDelete (id) {
      Swal.fire({
        title: 'Tem certeza?',
        text: 'Esta ação não pode ser desfeita!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#34c38f',
        cancelButtonColor: '#f46a6a',
        confirmButtonText: 'Sim, excluir!',
        cancelButtonText: 'Cancelar'
      }).then(async (result) => {
        if (result.value) {
          try {
            await this.deleteItem(id)
            successMessage('Foto excluída!')
            this.loadPhotos()
          } catch (error) {
            errorMessage('Erro ao excluir.')
          }
        }
      })
    }
  }
}
</script>
